import React, { ReactNode, useEffect, useState } from "react";
import { Box, styled, Theme, useMediaQuery } from "@mui/material";
import isPropValid from "@emotion/is-prop-valid";
import { TypographyWithInfoIcon } from "@components";

const TOP_NAVIGATION_HEIGHT = 54;

const BetaContainer = styled(Box, {
  shouldForwardProp: (prop: string) =>
    isPropValid(prop) || prop !== "keepRight",
})<{
  keepRight: boolean;
  scrollTop: number;
}>(({ theme, keepRight, scrollTop }) => ({
  backgroundColor: theme.palette.primary.dark,
  color: theme.palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  paddingRight: "25px",
  width: "200px",
  height: "40px",
  transform: "translateX(31px) rotate(25.32deg)",
  transformOrigin: "top",
  position: "fixed",
  right: 0,
  top: "-7px",
  zIndex: 6,
  ...(!keepRight
    ? {
        [theme.breakpoints.down("md")]: {
          transform:
            theme.type === "ftd"
              ? "translateX(-57px) rotate(-34.32deg)"
              : "translateX(-31px) rotate(-25.32deg)",
          paddingRight: "0",
          paddingLeft: theme.type === "ftd" ? "48px" : "30px",
          justifyContent: "flex-start",
          left: 0,
          right: "auto",
        },

        [theme.breakpoints.down("sm")]: {
          height: "20px",
          top: theme.type === "ftd" ? "-10px" : "-20px",
          transform:
            theme.type === "ftd"
              ? "translateX(-52px) rotate(-34.32deg)"
              : "translateX(-37px) rotate(-34.32deg)",
        },
      }
    : {
        [theme.breakpoints.down("sm")]: {
          height: "20px",
          top: `${scrollTop}px`,
          paddingRight: "34px",
          width: "135px",
          transform: "translateX(37px) rotate(34.32deg)",
        },
      }),
}));

export const Beta = ({
  title = "Beta",
  tooltipTitle,
  tooltip,
  keepRight = false,
}: {
  title?: string;
  tooltipTitle: string;
  tooltip: ReactNode;
  keepRight?: boolean;
}) => {
  const [scrollTop, setScrollTop] = useState(TOP_NAVIGATION_HEIGHT);
  const isLessSm = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  useEffect(() => {
    if (!keepRight) return;

    const handleScroll = () => {
      const top = TOP_NAVIGATION_HEIGHT - window.scrollY;
      setScrollTop(top < 0 ? 0 : top);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [keepRight]);

  return (
    <BetaContainer keepRight={keepRight} scrollTop={scrollTop}>
      <TypographyWithInfoIcon
        variant={isLessSm ? "caption" : "subtitle2"}
        textTransform="uppercase"
        fontWeight={600}
        color="common.white"
        openOnClick
        iconColor="common.white"
        tooltipTitle={tooltipTitle}
        hideIcon={isLessSm}
        tooltipText={tooltip}
      >
        {title}
      </TypographyWithInfoIcon>
    </BetaContainer>
  );
};
